export default [
  {
    path: '/main/user-web-service',
    meta: {
      tag: 'user-web-service',
      name: 'Usuário Web Service',
      breadcrumb: 'Usuário Web Service',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "user-web-service" */ '@/views/main/settings/app-frotix-registers/userwebservice/Add.vue')
  }
]
